<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-13 17:16:16
 * @FilePath: \mrc-ess-fronted\src\Page\Ess\Approval\Approval\components\forwardTo.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 14:13:27
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_RosterRecordForm_form_slide_dialog_selectSenderTitle')
    "
    @close="closeDialog"
    width="600"
    :dialog="show"
  >
    <template v-slot:content>
      <Stepper
        :curStep="curStep"
        :items="stepper"
        backgroundColor="white"
        contentClass=" py-3 px-8 mt-0 "
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <span class="text--secondary text-subtitle-2">{{
                  $t(
                    "label_essweb_approvalApplication_form_forward_isBackApproverLabel"
                  )
                }}</span>
              </v-col>
              <v-col xs="6" sm="4" md="3" lg="3" cols="12">
                <v-sheet
                  class="d-flex flex-row align-center"
                  @click="
                    nextNode == 0 ? ((nextNode = 1), (nowNode = 0)) : null
                  "
                >
                  <v-rating
                    v-model="nextNode"
                    size="25"
                    readonly
                    class="mx-2"
                    background-color="primary "
                    color="primary"
                    empty-icon="radio_button_unchecked"
                    full-icon="radio_button_checked"
                    :length="1"
                    dense
                  />
                  {{
                    $t(
                      "label_essweb_approvalApplication_form_back_nextNodeLabel"
                    )
                  }}
                </v-sheet>
              </v-col>
              <v-col xs="6" sm="4" md="3" lg="3" cols="12">
                <v-sheet
                  class="d-flex flex-row align-center"
                  @click="nowNode == 0 ? ((nowNode = 1), (nextNode = 0)) : null"
                >
                  <v-rating
                    size="25"
                    class="mx-2"
                    v-model="nowNode"
                    readonly
                    background-color="primary "
                    color="primary"
                    :length="1"
                    dense
                    empty-icon="radio_button_unchecked"
                    full-icon="radio_button_checked"
                  />
                  {{
                    $t(
                      "label_essweb_approvalApplication_form_back_nowNodeLabel"
                    )
                  }}
                </v-sheet>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-form ref="form2" lazy-validation>
            <v-row>
              <v-col>
                <AutoComplete
                  isRequired
                  v-model="curSender"
                  :items="allForward"
                  label="label_essweb_RosterRecordForm_form_slide_dialog_senderLabel"
                  :filter="$staffFilter"
                  chips
                  avatar
                  two-line
                  simple
                  hide-details
                  deletable-chips
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  item-text="staff_code"
                  item-value="staff_uuid"
                >
                  <template v-slot:selection.avatar="{ data }">
                    <StaffAvatar
                      left
                      contentClass="white--text"
                      :src="data.item.staff_avatar"
                      :staff_name="data.item.preferred_name"
                    />
                  </template>
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.preferred_name) }}
                  </template>
                  <template v-slot:item.avatar="{ data }">
                    <StaffAvatar
                      size="36"
                      :src="data.item.staff_avatar"
                      :staff_name="data.item.preferred_name"
                  /></template>
                  <template v-slot:item.title="{ data }"
                    ><span class="text-body-2"
                      >{{ $getCommonLangValue(data.item.preferred_name) }}
                      <span class="text--secondary text-caption-xs">{{
                        data.item.staff_code
                      }}</span>
                    </span></template
                  >
                  <template v-slot:item.subtitle="{ data }">{{
                    $getCommonLangValue(data.item.job_post_name)
                  }}</template>
                </AutoComplete>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </Stepper>
    </template>
    <template v-slot:actions>
      <CardActions
        :okBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="curStep = curStep + 1"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @ok="toSubmit"
        @cancel="closeDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "forwardTo",
  props: {
    show: { default: false, type: Boolean },
    staff_uuid: { default: null, type: [String, Number] },
    data_type: { default: null, type: [String, Number] },
    tr_uuid: { default: null, type: [String, Number] },
    flag: { default: null, type: [String, Number] },
    curUuid: { default: null, type: [String, Number] },
  },
  data() {
    return {
      allForward: [],
      curSender: null,
      stepper: [
        "label_essweb_approvalTemplate_form_dialog_step_generalLabel",
        "label_essweb_RosterRecordForm_form_slide_dialog_senderLabel",
      ],
      curStep: 1,
      nextNode: 1,
      nowNode: 0,
    };
  },
  computed: {
    ...mapGetters(["AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    curNode() {
      return this.nextNode == 1 ? 0 : 1;
    },
  },
  mounted() {
    this.getForwardList(this.curAppInfo["user"]["user_id"]);
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.curSender = null;
        this.nowNode = 0;
        this.nextNode = 1;
      }
    },
    data_type(val) {
      if (val) this.getForwardList(val);
    },
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getForwardList: function (id) {
      const that = this;
      let data = {
        uuid: this.curUuid,
        data_type: this.data_type,

        cancel_flag: this.flag,
      };
      if (this.data_type == 1) {
        data["~staff_uuid~"] = this.staff_uuid;
        data["leave_transaction_type_uuid"] = this.tr_uuid;
      }
      this.$Request({
        method: "POST",
        table: "unknown",
        url: "/approval/get-forward-list/",
        data: data,
        type: "client",
      }).then((res) => {
        that.allForward = res.data;
      });
    },
    removeStaff: function (item) {
      // const index = this.curSender.indexOf(item.staff_uuid);
      // if (index >= 0) this.curSender.splice(index, 1);
      this.curSender = null;
    },
    toSubmit: function () {
      const that = this;
      if (!this.$refs["form2"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("forward", this.curSender, this.curNode);
    },
  },
};
</script>